import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RdsFilterCbPipe } from './rds-filter-cb.pipe';
import { RdsFilterFieldsPipe } from './rds-filter-fields.pipe';
import { RdsFilterOptionsPipe } from './rds-filter-options.pipe';



@NgModule({
  declarations: [RdsFilterCbPipe, RdsFilterFieldsPipe, RdsFilterOptionsPipe],
  imports: [
    CommonModule
  ],
  exports: [RdsFilterCbPipe, RdsFilterFieldsPipe, RdsFilterOptionsPipe]
})
export class FinexPipesModule { }
